'use strict';

import { BaseController } from '../../../base/controller';
import _ from 'lodash';

export class CardFooterController extends BaseController {
  constructor(controllerService, cardService, featureFlagService) {
    'ngInject';
    super({ controllerService, cardService, featureFlagService });
  }

  get hasStates() {
    return !!(this.states && this.states.length);
  }

  get hideText() {
    return (
      this.states.length > 1 || (this.states.length === 1 && this.hasError)
    );
  }

  get erroredFields() {
    // Return only truthy error fields
    return _.pickBy(this.errorFields);
  }

  get erroredFieldsKeys() {
    return _.keys(this.erroredFields).join('.');
  }

  get showCancelContractBtn() {
    return this.featureFlagService.isFeatureActive(
      this.FeatureNames.FF_CONTRACT_CANCELLATION,
    );
  }

  $onInit() {}

  cancelContract($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.cancelContractClick();
  }

  callErrorHandler($event) {
    $event.preventDefault();
    $event.stopPropagation();

    const { errorClick } = this;
    if (angular.isFunction(errorClick)) {
      errorClick();
    }
  }
}
